import api from "../../../api";

export default function get() {
    return api.get(`/accounts`,);
}
